import { Box, Typography, Divider } from '@mui/material';
import { withTranslation, WithTranslation } from 'react-i18next';

import ModalBox from '@core/assistant/ModalBox';
import { useAssistant } from '@core/assistant/providers/Provider';
import { SCREENS } from '@core/assistant/interfaces';
import QuestionBox from '@core/assistant/QuestionBox';
import Form from '@core/assistant/Form';
import Tag from '@core/assistant/Tag';

import { useStyles } from './styles';
import { QUESTIONS } from './constants';

const HowToScreen = ({ t: translate }: WithTranslation) => {
  const classes = useStyles();

  const { setOpen, navigate, setNavigationHistory, stopPlayback } =
    useAssistant();

  const renderTitle = () => {
    return (
      <Box sx={classes.titleBox}>
        <Typography sx={classes.title}>Noa</Typography>
        <Tag />
      </Box>
    );
  };

  return (
    <ModalBox
      title={renderTitle()}
      onClose={() => {
        stopPlayback();
        setOpen(false);
        setNavigationHistory([]);
        navigate(SCREENS.DEFAULT);
      }}
      onBack={() => {
        navigate(SCREENS.DEFAULT, true);
      }}
    >
      <Typography sx={classes.text}>
        {translate('assistant.howTo.text1')}:
      </Typography>

      <Box sx={classes.questions}>
        {QUESTIONS.map(({ title, icon }, index) => (
          <QuestionBox key={index} title={translate(title)} icon={icon} />
        ))}
      </Box>

      <Divider sx={classes.divider} />

      <Typography sx={classes.text}>
        {translate('assistant.howTo.text2')}:
      </Typography>

      <Form />
    </ModalBox>
  );
};

export default withTranslation('common')(HowToScreen);
